// tslint:disable jsx-no-lambda
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertActions, globalActions } from "../../actions";

import { Redirect, Route, Switch } from "react-router-dom";

import { alertsClasses as myClasses } from "../";

import SideBar from "../sidebar/sidebar";
import Compose from "./compose/compose";
import Description from "./description/description";
import List from "./list/list";

import Empty from "src/controllers/alerts/empty/empty";

import { Alert, TabId, Text } from "@blueprintjs/core";
import {
  IMPDTreeNode,
  MPDAnimations
} from "src/mpd-library/";


import { RightPanelContainer, ToolBar } from "src/components";

import "./styles.css";

export interface IMPDAlertsProps {
  composeActive: boolean;
  composeTitleValue: string;
  list: Array<any>;
  windowHeight: number;
  isMobileSize: boolean;
  listItem: any;
  data: any;
  routeProps?: any;
  tabId: TabId;
  loading: boolean;
  rightPanelExpanded: boolean;
  topBarProps?: any;
  mobileSideBarActive?: boolean;
  warningContent: any;
  warningActive: boolean;
  onAlertData: () => (dispatch: Dispatch<any>) => Promise<void>;
  onWarningAction: (
    action: boolean
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onUpdateToolBar: (
    topBarProps: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
}

export class Alerts extends React.Component<IMPDAlertsProps> {
  constructor(props: any) {
    super(props);
    this.deSelectNode = this.deSelectNode.bind(this);
    this.onWarningAction = this.onWarningAction.bind(this);
    this.isEmpty = this.isEmpty.bind(this);
  }

  public componentWillMount() {
    this.props.onAlertData();
  }

  public render() {
    const {
      composeActive,
      listItem,
      rightPanelExpanded,
      mobileSideBarActive,
      warningActive,
      warningContent,
      isMobileSize,
      topBarProps,
      routeProps,
      onUpdateToolBar,
      windowHeight,
      ...remaining
    } = this.props;

    const pathname = routeProps.history.location.pathname;
    const pathnameArr = pathname.split('/');
    const mobileActive =
      pathname.includes("dashboard") || pathname.includes("compose");

    return (
      <div className={myClasses.ALERTS_CONTAINER}>
        <SideBar
          routeProps={routeProps}
          active={mobileSideBarActive}
          homeGroupIndex={1}
          homeItemIndex={0}
        />
        <Route
          path={"/alerts/"}
          exact={isMobileSize}
          render={() => (
            <List
              routeProps={routeProps}
              {...remaining as any}
            />
          )}
        />
        {((isMobileSize && mobileActive) || !isMobileSize) && (
          <RightPanelContainer 
            expanded={rightPanelExpanded} 
            animationProps={{
              animation: MPDAnimations.growOut,
              animationActive: isMobileSize
            }}
            >
              <ToolBar className={pathnameArr[pathnameArr.length - 1]} {...topBarProps} key={routeProps.history.location} />
              <Switch location={routeProps.history.location}>
                <Route
                  exact={true}
                  path={"/alerts/"}
                  render={() => (
                    <Empty
                      title="No Alert Selected"
                      onUpdateToolBar={onUpdateToolBar}
                    />
                  )}
                />
                {listItem === null && (
                  <Redirect from="/alerts/dashboard" to="/alerts/" />
                )}
                <Route
                  exact={true}
                  path={"/alerts/dashboard"}
                  render={() => (
                    <Description
                      routeProps={routeProps}
                      onUpdateToolBar={onUpdateToolBar}
                      {...remaining as any}
                    />
                  )}
                />
                <Route
                  path={"/alerts/compose/"}
                  render={() => (
                    <Compose
                      routeProps={routeProps}
                      onUpdateToolBar={onUpdateToolBar}
                      {...remaining as any}
                    />
                  )}
                />
              </Switch>
          </RightPanelContainer>
        )}
        <Alert
          className="generic-alert"
          isOpen={warningActive}
          cancelButtonText="Cancel"
          onCancel={e => this.onWarningAction(e, false)}
          onConfirm={e => this.onWarningAction(e, true)}
          confirmButtonText="Okay"
        >
          <div className="inner-container">
            <Text> {warningContent.header} </Text>
            <p>{warningContent.body}</p>
          </div>
        </Alert>
      </div>
    );
  }

  private isEmpty() {
    const { routeProps, listItem } = this.props;
    const pathname = routeProps.history.location.pathname;
    if (listItem === null && !pathname.includes("compose")) {
      return true;
    }
    return false;
  }

  private onWarningAction(event: any, action: boolean) {
    this.props.onWarningAction(action);
  }

  private deSelectNode(currentNode?: IMPDTreeNode) {
    if (currentNode) {
      currentNode.isSelected = false;
      currentNode.isExpanded = false;
    }
  }
}

const mapStateToProps = (state: any) => {
  const { alerts, global } = state;
  const { isMobileSize, topBarProps, windowHeight } = global;
  const {
    composeActive,
    list,
    listItem,
    data,
    listItemType,
    rightPanelExpanded,
    tabId,
    warningActive,
    warningContent
  } = alerts;

  const { mobileSideBarActive } = global;

  return {
    composeActive,
    isMobileSize,
    data,
    list,
    topBarProps,
    listItem,
    listItemType,
    rightPanelExpanded,
    mobileSideBarActive,
    tabId,
    warningActive,
    warningContent,
    windowHeight
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onUpdateToolBar: bindActionCreators(globalActions.onUpdateToolBar, dispatch),
    onAlertData: bindActionCreators(alertActions.onGetData, dispatch),
    onWarningAction: bindActionCreators(alertActions.onWarningAction, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);



// WEBPACK FOOTER //
// ./src/controllers/alerts/alerts.tsx